import { Collapse, Typography } from 'antd';
import React from 'react';
import * as S from './DealRoomSection.styles';

const { Title, Text } = Typography;
export const { Panel } = Collapse;

export const Earthquake: React.FC = () => {
  return (
    <S.Wrapper>
      <S.Header>
        <Title level={2} className="main-title">
          {`שאלות ותשובות בנושא רעידת אדמה`}
        </Title>
        <Text className="sub-text">{`ביטוח מבנה לבית המשותף הוא מהחשובים שבביטוחים עבור ועדי בתים. הוא מכסה נזקים באזורים המשותפים של הבניין, בהם: חדר מדרגות, מעליות, לובי, חדר אשפה, חנייה ועוד. נזקים באזורים אלו יכולים להתחיל בעלות של אלפי שקלים ולהגיע עד מיליוני שקלים!
  אם הבניין לא מכוסה בביטוח מבנה - בעלי ובעלות הדירות יאלצו לשלם את הסכומים האלו מכיסם.`}</Text>
      </S.Header>
      <S.ContentTextWrapper className="mt-24">
        <S.ListWrapper className="number skip">
          <S.ListItem>
            <S.ListTitle>{`מה מכסה סעיף רעידת אדמה בביטוח בית משותף?`}</S.ListTitle>
            <S.ListContent>{`הסעיף מכסה נזקים שייגרמו לרכוש המשותף כתוצאה מרעידת אדמה או צונאמי.
הרכוש המשותף הינו כל החלקים המשותפים בבניין כגון: לובי, מעליות, חדר גנרטורים, חדר משאבות, מקלט, חדר מדרגות, לוח חשמל ראשי של הבניין, צנרת מים/ביוב/הסקה של הבניין, דחסנית אשפה, חדר דיירים, גג ומתקנים משותפים שנמצאים על הגג, חניון תת קרקעי, מערכות כיבוי אש הפזורות בבניין (צנרת כיבוי אש, מערכת ספרינקלרים וכו')`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`האם סכום הביטוח שבפוליסת בית משותף יספיק לבנות את כל הבניין מחדש?`}</S.ListTitle>
            <S.ListContent>{`לא, ביטוח בית משותף מכסה את הרכוש המשותף בלבד.
קיימים שני מצבים לאחר מקרה רעידת אדמה:`}</S.ListContent>
            <S.ListContent>
              <S.ListWrapper className="normal-number">
                <S.ListItem>
                  <S.ListContent>{`רעידת האדמה לא גרמה להרס מוחלט בבניין, אך נגרמו נזקים רבים לרכוש המשותף ולכמה דירות. לדוגמה: שתי מעליות קרסו, חלק מהחניון התת קרקעי ניזוק, חדר מדרגות ולובי ניזוקו, מערכת ביוב קרסה ויש צורך להחליפה בחדשה, ועוד 4-5 דירות ניזוקו. נניח שהנזק לרכוש המשותף מסתכם ב-3,000,000 ₪, בדיוק בשביל זה נרכש הביטוח. הוועד אחראי להחזיר את הרכוש המשותף לקדמותו, למצב נורמלי של חיים בבניין ובמקרה זה סעיף רעידת אדמה מציל את הדיירים בבניין.
רעידת אדמה גרמה להרס מוחלט לבניין. במצב כזה כל בעלי הדירות צריכים להפעיל את ביטוח הדירה שלהם. סכום הכסף שייאסף מכל דירה ביחד עם סכום הביטוח של רכוש משותף אמור לשמש לבנייה של הבניין מחדש.`}</S.ListContent>
                </S.ListItem>
                <S.ListItem>
                  <S.ListContent>{`רעידת אדמה גרמה להרס מוחלט לבניין. במצב כזה כל בעלי הדירות צריכים להפעיל את ביטוח הדירה שלהם. סכום הכסף שייאסף מכל דירה ביחד עם סכום הביטוח של רכוש משותף אמור לשמש לבנייה של הבניין מחדש.`}</S.ListContent>
                </S.ListItem>
              </S.ListWrapper>
            </S.ListContent>
            <S.ListContent>{`סביר להניח שאם הבניין קרס אז הוא חלק מהרס מוחלט של כל השכונה. גם אם יש ביטוח דירה לכל הדיירים בבניין + ביטוח לוועד על רכוש משותף, כיצד קבלנים יגיעו לבנות הבניין מחדש בתוך אזור הרוס לגמרי?
להערכתינו לקוחות שנשארו בחיים ושרדו את הארוע, יקחו את כספי הביטוח ויעברו לגור במקום אחר. המדינה ככול הנראה תבנה תוכנית מתאר חדשה לרובע ובעתיד הדיירים יקבלו דירה חדשה, הדבר ייקח בין 5-10 שנים מיום הארוע.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`האם עדיין מומלץ לרכוש ביטוח לרעידת אדמה?`}</S.ListTitle>
            <S.ListContent>{`חד משמעית – כן. תפקידו של ועד הבית הוא לדאוג לתקן נזקים ברכוש משותף במקרה
של הרס חלקי ולשפץ את הבניין כדי להחזיר את המצב לקדמותו.`}</S.ListContent>
          </S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </S.Wrapper>
  );
};
